/**
 * erc-ga-events.js
 * Convención de tagging consultorseo (set cerrado) → dataLayer → GTM-5S3DXSBK → GA4.
 *
 * CLICS (lee los atributos data-ga-* del elemento, ya normalizados al set cerrado):
 *   whatsapp_click  ← <a href="wa.me / api.whatsapp.com / whatsapp://">
 *   phone_click     ← <a href="tel:...">
 *   email_click     ← <a href="mailto:...">
 *   Cada uno empuja event_category / event_action / event_label.
 *   En GTM: un disparador Custom Event por nombre + tag GA4 que reenvía los 3 parámetros.
 *
 * FORMULARIOS (regla de oro: medir el ENVÍO EXITOSO, no el clic):
 *   form_submit → GA4 generate_lead. Se dispara cuando Shopify confirma el envío
 *   (form 'contact' → ?contact_posted=true o mensaje de éxito .form-status.form__message).
 *   Empuja form_category='form', form_action (nombre del form), form_label (detalle).
 *
 * Nota: checkout y compra (begin_checkout / purchase) NO van aquí: se miden con un
 * Web Pixel en Shopify → Settings → Customer Events (el checkout corre en sandbox).
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function push(payload) {
    window.dataLayer.push(payload);
  }

  // Helper expuesto para empujes inline desde Liquid (p. ej. product_view).
  window.ercTrack = function (name, category, label, extra) {
    var p = { event: name, event_category: category, event_label: label || '' };
    if (extra) {
      Object.keys(extra).forEach(function (k) { p[k] = extra[k]; });
    }
    push(p);
  };

  function isWhatsApp(href) {
    return /(?:wa\.me|api\.whatsapp\.com|whatsapp:\/\/)/i.test(href);
  }

  function pageFallback() {
    return (document.body && document.body.getAttribute('data-page-type')) || 'body';
  }

  // ---- CLICS de contacto (whatsapp / phone / email) ----
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    var name, defaultCategory, defaultLabel;

    if (isWhatsApp(href)) {
      name = 'whatsapp_click';
      defaultCategory = 'whatsapp';
      defaultLabel = link.href;
    } else if (href.indexOf('tel:') === 0) {
      name = 'phone_click';
      defaultCategory = 'phone';
      defaultLabel = href.replace('tel:', '').trim();
    } else if (href.indexOf('mailto:') === 0) {
      name = 'email_click';
      defaultCategory = 'email';
      defaultLabel = href.replace('mailto:', '').trim();
    } else {
      return;
    }

    push({
      event: name,
      event_category: link.getAttribute('data-ga-category') || defaultCategory,
      event_action: link.getAttribute('data-ga-action') || pageFallback(),
      event_label: link.getAttribute('data-ga-label') || defaultLabel
    });
  }, true);

  // ---- FORM: envío EXITOSO de formulario de lead → generate_lead ----
  function pushLead(action, label) {
    push({
      event: 'form_submit',
      form_category: 'form',
      form_action: action || 'contacto',
      form_label: label || ''
    });
  }

  function checkContactSuccess() {
    var params = new URLSearchParams(window.location.search);
    var byUrl = params.get('contact_posted') === 'true';
    var byDom = !!document.querySelector('.form-status.form__message');
    if (!byUrl && !byDom) return;

    // form_label = handle/path de la página donde se envió el lead.
    var source = window.location.pathname.replace(/^\/|\/$/g, '') || 'home';
    pushLead('contacto', source);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkContactSuccess);
  } else {
    checkContactSuccess();
  }
})();
